import React from 'react';

const SentinelOne = () => {
  return (
    <>
      <section className="sentinelONE">
        <div className="w1300">
          <ul>
            <li className="flex">
              <div className="text">
                <h2>
                  <span className="red">랜섬웨어</span>에 감염 되었다면?!
                </h2>
                <p>
                  타겟화, 고도화 하고 있는 랜섬웨어에 <br className="w500" />
                  어떻게 대응하고 계신가요?
                  <br />
                  기존 EndPoint 보안솔루션은, 랜섬웨어가 <br className="w500" />
                  감염되면
                  <br className="dis500" />
                  해커에 요구를 들어주거나
                  <br className="w500" /> 백업 밖에 방법이 없었습니다.
                </p>
              </div>
              <div className="image">
                <figure>
                  <img src="/images/sub_sentinel_01.png" alt="" className="pc" />
                  <img src="/images/sub_sentinel_01_1300.png" alt="" className="w1300" />
                  <img src="/images/sub_sentinel_01_400.png" alt="" className="w400" />
                </figure>
              </div>
            </li>
            <li className="flex">
              <div className="image">
                <figure>
                  <img src="/images/sub_sentinel_02.png" alt="" className="pc" />
                  <img src="/images/sub_sentinel_02_1300.png" alt="" className="w1300" />
                  <img src="/images/sub_sentinel_02_400.png" alt="" className="w400" />
                </figure>
              </div>
              <div className="text">
                <h2>
                  관리 콘솔을 통한 빠른
                  <br /> 초동 원격조치 및 복구기능
                </h2>
                <p>
                  아마존 Cloud에 있는 관리콘솔로 <br className="w500" />
                  언제, 어디서든 원격 초동 조치로
                  <br className="vis1300" /> 2차 피해를
                  <br className="dis1300" />
                  예방할 수 있으며, 직관적인 Attack Story Line으로 <br className="w1300" />
                  빠른 취약점 분석이 가능합니다.
                </p>
              </div>
            </li>
            <li className="flex">
              <div className="text">
                <h2>
                  SentinelOne은 랜섬웨어 감염 시 <br /> 복구가 가능한 EDR 솔루션 입니다!
                </h2>
                <p>
                  특허받은 Windows vss 스냅샷 기능을
                  <br className="w500" /> 활용하여, 클릭 몇 번만으로 <br className="w530" />
                  랜섬웨어 감염 전으로 복구가 가능합니다!
                </p>
              </div>
              <div className="image">
                <figure>
                  <img src="/images/sub_sentinel_03.png" alt="" className="pc" />
                  <img src="/images/sub_sentinel_03_1300.png" alt="" className="w1300" />
                  <img src="/images/sub_sentinel_03_400.png" alt="" className="w400" />
                </figure>
              </div>
            </li>
          </ul>
        </div>
      </section>
      <section className="endPoint">
        <div className="title">
          <h2>
            엔드포인트 플랫폼 <br className="w590" />
            SentinelOne
          </h2>
        </div>
        <div className="wrap">
          <div className="w1200 flex">
            <figure className="image">
              <img src="/images/sub_sentinel_04.png" alt="" />
            </figure>
            <div className="text">
              <h3>
                차세대 엔드포인트 보안 - <br className="w400" />
                엔드포인트란?
              </h3>
              <div className="topTxt">
                <p className="subTit">엔드포인트의 정의</p>
                <div className="smallP">
                  <p>- 네트워크의 끝 단에 위치한 단말/디바이스 </p>
                  <p>- 데이터 접근/처리/저장</p>
                  <p>- PC, 서버, VDI, Cloud, 모바일 등</p>
                </div>
              </div>
              <div className="botmTxt">
                <p className="subTit">엔드포인트의 중요성</p>
                <div className="smallP">
                  <p>- 해커의 최종 목적지 & 우리의 최종 방어선</p>
                  <p>- 다양한 침투경로 (USB, 피싱, 악성 이메일/URL)</p>
                  <p>- 악성 행위가 실제로 발생하는 곳</p>
                  <div>
                    <p>&rarr; 해커의 의도를 가장 잘 파악할 수 있는 위치</p>
                    <p>&rarr; 가장 정확한 진단 가능한 위치</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="endPoint01">
        <div className="w1200">
          <h2>
            네트워크 경계보안을 통한 <span className="space">악성코드 유입/해킹 차단 한계</span>
          </h2>
          <figure>
            <img src="/images/sub_sentinel_05.png" alt="" className="pc" />
            <img src="/images/sub_sentinel_05_800.png" alt="" className="w800" />
            <img src="/images/sub_sentinel_05_400.png" alt="" className="w400" />
          </figure>
        </div>
      </section>
      <section className="endPoint02">
        <div className="w1200">
          <h2>엔드포인트 보안요건</h2>
          <ul>
            <li>
              <h3>
                인공지능 기반 <span className="space">탐지/차단/대응 자동화</span>
              </h3>
              <figure>
                <img src="/images/sub_sentinel_06.png" alt="" className="pc" />
                <img src="/images/sub_sentinel_06_800.png" alt="" className="w800" />
              </figure>
            </li>
            <li>
              <h3>SentinelOne 아키텍쳐</h3>
              <figure>
                <img src="/images/sub_sentinel_07.png" alt="" className="pc" />
                <img src="/images/sub_sentinel_07_800.png" alt="" className="w800" />
              </figure>
            </li>
          </ul>
        </div>
      </section>
      <section className="mainFunction">
        <div className="w1200">
          <h2>SentinelOne 주요 기능</h2>
          <ul>
            <li>
              <h3>
                모든 형태의 공격에 대해 통합 <span className="space">방어 제공</span>
              </h3>
              <figure>
                <img src="/images/sub_sentinel_08.png" alt="" className="pc" />
                <img src="/images/sub_sentinel_08_800.png" alt="" className="w800" />
                <img src="/images/sub_sentinel_08_400.png" alt="" className="w400" />
              </figure>
            </li>
            <li>
              <h3>
                실시간 자동/원격 사고대응 – <br className="w700" />
                <span className="small"> 네트워크 격리, 원격 명령실행, 시스템종료 등</span>
              </h3>
              <figure>
                <img src="/images/sub_sentinel_09.png" alt="" className="pc" />
                <img src="/images/sub_sentinel_09_800.png" alt="" className="w800" />
                <img src="/images/sub_sentinel_09_400.png" alt="" className="w400" />
              </figure>
            </li>
          </ul>
        </div>
      </section>
      <section className="features">
        <div className="w1200">
          <h2>SentinelOne 특장점</h2>
          <h3>
            AI 기술 및 피해 자동 복구 기술 <br className="w620" />
            <span className="space"> 等 핵심 경쟁력 보유</span>
          </h3>
          <div className="soneGrid">
            <div className="item">
              <h4>악성코드 및 해킹 탐지를 위한 독자적 AI 기술 보유</h4>
              <p>
                전파분석을 통한 최적의 Site 치국 Big Data를 고려한 최상의 Access망 설계 신공법을
                적용한 공간효율적인 기지국 시공 무선국 신고/허가/검사 업무 대행/품질측정 및 Test
              </p>
            </div>
            <div className="item">
              <h4>
                랜섬웨어 등에 의한 데이터 피해 자동복구
                <br className="w1300" /> (EDR 솔루션 중 유일)
              </h4>
              <p>18년 데이터 자동복구 기술 특허 획득</p>
            </div>
            <div className="item">
              <h4>
                Light-Agent 방식으로 Endpoint 성능 부하를 <br className="w1300" /> 최소화하는 구조
              </h4>
              <p>로컬에서 초기 분석 진행, 상세분석은 분석서버/클라우드에서 진행</p>
            </div>
            <div className="item">
              <h4>
                Cloud, On-Premise, <br /> Hybrid 모두 지원
              </h4>
            </div>
          </div>
          <ul>
            <li>
              <h3>
                3rd Party 기관의 우수한 평가&nbsp;
                <br className="w620" />
                <span className="space"> (NSS Lab -2017)</span>
              </h3>
              <figure>
                <img src="/images/sub_sentinel_10.png" alt="" className="pc" />
                <img src="/images/sub_sentinel_10_800.png" alt="" className="w800" />
              </figure>
            </li>
          </ul>
        </div>
      </section>
    </>
  );
};

export default SentinelOne;
